export enum AVAILABLE_COMPONENTS {
  'horizontalCheckbox' = 'horizontalCheckbox',
  'date' = 'date',
  'radioList' = 'radioList',
  'checkboxList' = 'checkboxList',
  'multiSearchSelect' = 'multiSearchSelect',
  'booleanInput' = 'booleanInput',
  'horizontalCheckboxList' = 'horizontalCheckboxList',
  'checkFactionChip' = 'checkFactionChip',
  'checkSetChip' = 'checkSetChip',
  'bigDivider' = 'bigDivider',
  'price' = 'price',
}
